import CustomButton from 'components/buttons/CustomButton'
import React, { useEffect, useState } from 'react'
import FontAwesome from 'react-fontawesome'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { addComplaintSuccess, deleteComplaintSuccess, editComplaintSuccess, fetchComplaintSuccess } from 'store/actions/resourceActions'
import I18n from '../../resources/i18n/I18n'
import ComplaintApi from '../../services/complaintApi'
import LabelEdition from './LabelEdition'

const ComplaintEdition = () => {
  const [error, setError] = useState(null)
  const dispatch = useDispatch()
  const history = useHistory()

  const complaints = useSelector((state) => state.resourceReducer.complaints)

  useEffect(() => {
    if (complaints.length === 0) {
      ComplaintApi.getComplaintList().then((response) => dispatch(fetchComplaintSuccess(response)))
    }
  }, [complaints.length, dispatch])

  const goBack = () => {
    history.push('/configuration')
  }

  const deleteComplaint = (complaint) => {
    setError(null)
    ComplaintApi.deleteComplaint(complaint.id)
      .then(() => dispatch(deleteComplaintSuccess(complaint)))
      .catch(() => setError(I18n.t('ErrorDelete')))
  }

  const editComplaint = (complaint) => {
    ComplaintApi.editComplaint(complaint).then(() => dispatch(editComplaintSuccess(complaint)))
  }

  const createComplaint = (label) => {
    ComplaintApi.addComplaint({ label: label }).then((complaint) => dispatch(addComplaintSuccess(complaint)))
  }

  return (
    <div className="container-fluid">
      <LabelEdition items={complaints} deleteLabel={deleteComplaint} editLabel={editComplaint} createLabel={createComplaint} error={error} />
      <div className="row justify-content-center p-4">
        <CustomButton onClick={goBack} icon={<FontAwesome name="arrow-left" />} small secondary />
      </div>
    </div>
  )
}

export default ComplaintEdition
